import Vue from 'vue';
// src: https://docs.sentry.io/platforms/javascript/vue/
import * as Sentry from '@sentry/vue';

import {env} from '@/services/env.service';
import config from '@/services/config.service';

let contextProvider: (() => any) | null = null;
let sentryCfg: any;

if (env.MODE !== 'development' && env.MODE !== 'testing') {
  sentryCfg = {
    Vue,
    dsn: env.VITE_SENTRY_URL,
    logErrors: true,
    environment: config.env || 'production',
    denyUrls: [/\.(odin)/g],
    ignoreErrors: [
      'ws-abort',
      'CanceledError',
    ],
  };
  Sentry.init(sentryCfg);
  // DEV: test sentry by throwing any error
  (window as any).__test_sentry_integration__ = (
    logExplicit: boolean = false
  ) => {
    const errorMessage = 'example error to test sentry';
    if (logExplicit) {
      logError(errorMessage);
    }
    throw new Error(errorMessage);
  };
}

export function logError(
  value: string | Error,
  additionalContext?: any /* must be value which can be JSON.stringify(-ied) */
): string | undefined {
  if (contextProvider) {
    const context = contextProvider();
    if (additionalContext) {
      context._additionalContext = JSON.stringify(additionalContext);
    }
    setContext(context);
  }

  value = normalizeErrorValue(value);

  if (env.MODE !== 'development') {
    // @ts-ignore
    Sentry.captureException(value, value instanceof Error ? undefined : value);
  } else {
    // eslint-disable-next-line no-console
    console.error(value);
  }

  return undefined;
}

export function setContextProvider(provider: () => any, immediate = true) {
  contextProvider = provider;
  if (immediate) {
    setContext();
  }
}

export function setContext(context?: any) {
  context = context || (contextProvider && contextProvider());

  Sentry.configureScope(scope => {
    scope.setUser({ username: context.login });
    Object.keys(context).forEach(key => {
      scope.setExtra(key, context[key]);
    });
  });
}

export function normalizeErrorValue(value: any) {
  if (typeof value === 'string') {
    value = new Error(value);
  } else if (typeof value === 'object' && !(value instanceof Error)) {
    value = new Error(JSON.stringify(value));
  }
  return value;
}
